import './assets/main.css'
import { createApp } from 'vue'
import { pinia } from '@/stores'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import slider from 'vue3-slider'
import router from '@/router/'
import i18n from './i18n'
import { installDomainTrans } from '@/i18n/domainTrans'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'
import App from './App.vue'
import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faPlus,
  faMinus,
  faXmark,
  faArrowLeftLong,
  faUser,
  faRotateLeft,
  faArrowUp,
  faArrowDown,
  faEyeSlash,
  faEye,
  faMoon,
  faSun,
  faAngleDown,
  faAngleUp
} from '@fortawesome/free-solid-svg-icons'

import HttpService from '@/services/http.service'
import vAdjustPosition from '@/directives/v-adjust-positioning'
import { useEnvironmentStore } from '@/stores/environmentStore'

import { startQueue } from "@/services/mutationQueue";

library.add(
  faPlus,
  faMinus,
  faXmark,
  faArrowLeftLong,
  faUser,
  faRotateLeft,
  faArrowUp,
  faArrowDown,
  faEyeSlash,
  faEye,
  faMoon,
  faSun,
  faAngleDown,
  faAngleUp
)

pinia.use(piniaPluginPersistedstate)
const vfm = createVfm()


const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(slider)
  .use(ToastPlugin)
  .use(vfm)
  .use(i18n)
  .use(installDomainTrans)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('http-service', HttpService)
  .directive('adjust-position', vAdjustPosition)

startQueue();

const env = useEnvironmentStore()
env.hydrateFromStorage?.()

if (__DEMO__) {
  import('@/demo/install').then(({ installDemoFeatures }) => {
    installDemoFeatures(pinia)
  })
}

env.guessDefaultLocale().then((locale) => {
  env.setLocale(locale).then(() => {
    app.mount('#app')
  })
})
